import {
  BUTTON_STYLE_BY_STATUS,
  ButtonStyle,
  FOOTER_MODALS_TYPE,
  FOOTER_VARIANT_TYPE,
  ThemeKeyType
} from '@/components/AdvertisePayments/components/Footer/Footer.types';
import { PaymentTypeEnum } from '@/constants/common';

export const buttonStyleByVariants: Record<ThemeKeyType, ButtonStyle> = {
  [BUTTON_STYLE_BY_STATUS.DEFAULT_LIGHT]: {
    background: 'var(--system-blue)',
    labelColor: 'var(--bg-main)'
  },
  [BUTTON_STYLE_BY_STATUS.DEFAULT_DARK]: {
    background: 'var(--system-blue)',
    labelColor: 'var(--textAndLabels-main)'
  },
  [BUTTON_STYLE_BY_STATUS.PREMIUM_LIGHT]: {
    background: 'var(--bg-premium)',
    labelColor: 'var(--bg-main)',
    labelColorTablet: 'var(--textAndLabels-main)'
  },
  [BUTTON_STYLE_BY_STATUS.PREMIUM_DARK]: {
    background: 'var(--bg-premium)',
    labelColor: 'var(--textAndLabels-main)',
    labelColorTablet: 'var(--bg-main)'
  },
  [BUTTON_STYLE_BY_STATUS.MAIN_LIGHT]: {
    background: 'var(--textAndLabels-main)',
    labelColor: 'var(--bg-main)',
    labelColorTablet: 'var(--bg-main)'
  },
  [BUTTON_STYLE_BY_STATUS.MAIN_DARK]: {
    background: 'var(--textAndLabels-secondary)',
    labelColor: 'var(--bg-main)',
    labelColorTablet: 'var(--bg-main)'
  },
  [BUTTON_STYLE_BY_STATUS.CANCEL_LIGHT]: {
    background: 'var(--bg-secondary)',
    labelColor: 'var(--textAndLabels-main)',
    labelColorTablet: 'var(--textAndLabels-main)'
  },
  [BUTTON_STYLE_BY_STATUS.CANCEL_DARK]: {
    background: 'var(--bg-secondary)',
    labelColor: 'var(--textAndLabels-main)',
    labelColorTablet: 'var(--textAndLabels-main)'
  }
};

const fallbackStyle: ButtonStyle = {
  background: 'inherit',
  labelColor: 'inherit'
};

export const getButtonStyle = (
  styledVariant: FOOTER_VARIANT_TYPE,
  isDark: boolean
): ButtonStyle => {
  if (!styledVariant) return fallbackStyle;

  const themeMode = isDark ? 'dark' : 'light';
  const key = `${styledVariant}_${themeMode}` as ThemeKeyType;

  return buttonStyleByVariants[key] ?? fallbackStyle;
};

export const getFooterVariant = (type: string) => {
  switch (type) {
    case PaymentTypeEnum.PUBLICATION:
      return FOOTER_MODALS_TYPE.CANCEL_CONTINUE;

    case PaymentTypeEnum.ADVERTISE:
      return FOOTER_MODALS_TYPE.PAY_WITH_DISCLAIMER;

    default:
      return FOOTER_MODALS_TYPE.CONTINUE;
  }
};
